import { FolderApi, ThreadApi } from '../api-typings/messages/messages_types';
import { Message } from '../message/message.model';
import { transformMessages } from '../message/message.transformers';
import { Thread } from './thread.model';

// TODO: thread: any inference needs to go. ContextApi is incorrect.
export function transformThread(
  thread: ThreadApi,
  userId: string,
): Thread | undefined {
  const baseThread = thread.thread;

  if (!baseThread.id || !baseThread.owner) {
    return undefined; // FIXME Throw an error
  }

  const userReadTimes = Object.entries(baseThread.user_read_times || {}).reduce(
    (acc: Thread['userReadTimes'], [memberId, readTime]) => ({
      ...acc,
      [memberId]: readTime * 1000,
    }),
    {},
  );

  const messages: Message[] =
    (thread.messages && thread.messages.map(transformMessages)) || [];

  return {
    attachments: undefined,
    context: baseThread.context,
    folder: thread.folder || FolderApi.INBOX,
    id: thread.id,
    isFake: false,
    isMuted: thread.is_muted || false,
    isRead: thread.is_read || false,
    members: baseThread.members || [],
    inactiveMembers: baseThread.inactive_members || [],
    message: baseThread.message
      ? transformMessages(baseThread.message)
      : undefined,
    messageCount: thread.message_count,
    messageUnreadCount: thread.message_unread_count || 0,
    messages,
    otherMembers: baseThread.members.filter(m => m !== Number(userId)),
    owner: baseThread.owner,
    threadType: baseThread.thread_type,
    timeCreated: (baseThread.time_created || 0) * 1000,
    timeRead: (thread.time_read || 0) * 1000,
    timeUpdated: (thread.time_updated || 0) * 1000,
    userReadTimes,
  };
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/datastore/thread/thread.transformers.ts